import { render, staticRenderFns } from "./EditarProcedimentoOrigemLicitacaoPropria.vue?vue&type=template&id=0c18297d&scoped=true"
import script from "./EditarProcedimentoOrigemLicitacaoPropria.vue?vue&type=script&lang=ts"
export * from "./EditarProcedimentoOrigemLicitacaoPropria.vue?vue&type=script&lang=ts"
import style0 from "./EditarProcedimentoOrigemLicitacaoPropria.vue?vue&type=style&index=0&id=0c18297d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18297d",
  null
  
)

export default component.exports